import { onMounted, ref } from 'vue';
import { isRunningInNativeApp } from '~/utils/browserInfo';

/**
 * `true` quando a pagina roda dentro do app nativo iOS (RN WebView) — usado
 * pra aplicar padding de safe-area (topo/rodape) em superficies fora do header
 * (barra do jogo, rodape, etc.).
 *
 * Gateado ao app nativo de proposito: fora do app (browser/PWA) o proprio
 * navegador cuida das areas seguras, entao nao mexemos. Resolvido no client
 * porque le `navigator`/`window`, indisponiveis no SSR.
 */
export function useIsIosNativeApp() {
  const { isIosDevice } = useLayout();
  const isIosApp = ref(false);

  onMounted(() => {
    isIosApp.value = isIosDevice.value && isRunningInNativeApp();
  });

  return isIosApp;
}
